import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { buildApiUrl, secureFetch, apiRequest } from "@/lib/queryClient";
import type { PersonalisedProfile } from "@shared/schema";

export function usePersonalisedProfile() {
  return useQuery<PersonalisedProfile>({
    queryKey: ["personalised-profile"],
    queryFn: async () => {
      const res = await secureFetch(buildApiUrl("/api/user-profile"), {
        credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to fetch profile");
      return res.json();
    },
  });
}

export function useUpdatePersonalisedProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Partial<PersonalisedProfile>) => {
      return apiRequest("PATCH", "/api/user-profile", data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["personalised-profile"] });
    },
  });
}
